export default {
  menu: 'Menu',
  wineList: 'Carta vini',
  locale: 'Seleziona la lingua<br/> per accedere al menu:',
  claim:
    'Dalla terrazza,<br/> ogni piatto racconta la storia,<br/> ogni sguardo scopre l’orizzonte.',
  claimWine: 'Una terrazza sulla storia,<br /> un brindisi al territorio.',
  appetizer: 'Salumi, formaggi e oltre',
  'hot-dishes': 'Piatti caldi',
  'fish-dishes': 'Sapori dal mare',
  dessert: 'Dulcis in fundo',
  drinks: 'Da bere e da gustare',
  cocktail: 'Alchimie nel bicchiere',
  coffee: 'Momento Caffè',
  spirits: 'Essenza Distillata',
  beer: 'Malto e luppolo in festa',
  bollicine: 'Valdobbiadene DOCG & CO',
  altreBollicine: 'Altre bollicine locali',
  champagne: 'Metodo classico e Champagne',
  viniBianchi: 'Vini bianchi',
  viniRossi: 'Vini rossi',
  glass: 'Calice',
  bottle: 'Bottiglia',
  takeAway: 'Da asporto',
  social: 'Seguici sui social',
  service: 'Coperto 2 €',
  info: 'Per informazioni su allergeni e intolleranze, rivolgersi al personale.<br/> Alcuni prodotti possono essere surgelati.',
  time: 'Orario di apertura',
  contacts: 'Contatti',
  directions: 'Indicazioni',
  monday: 'Lunedì',
  tuesday: 'Martedì',
  wednesday: 'Mercoledì',
  thursday: 'Giovedì',
  friday: 'Venerdì',
  saturday: 'Sabato',
  sunday: 'Domenica',
  close: 'Chiuso',
  contact: 'Contatti',
}
